/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-02-01T10:21:40-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-12T14:38:14-07:00
*/

import React, { Component } from 'react';
import glamorous from 'glamorous';
import MailItem from './MailItem';
import Panel from '../../common/Panel';
import BlankSlate from '../../blocks/BlankSlate';
import isEmpty from 'lodash/isEmpty';

const MsgList = glamorous.ul({
  backgroundColor: '#fff',
  listStyle: 'none',
  padding: '0',
  margin: '0',
});

class MailList extends Component {

  render() {
    const {
      mail,
      refreshAccount,
      pageType,
      myProfile,
      isFetching
    } = this.props;
    
    // show new panel that lets user their profile is pending approval.
    if(!myProfile.is_approved) {
      return (
        <BlankSlate title='Want to message?'
           message='Your profile is currently being reviewed. Confirm your email address and once approved, you will be notified via email.'/>
      )
    }

    if(!isFetching && isEmpty(mail)) {
      return (<BlankSlate title='No messages yet'/>)

    } else {
      const list = Object.keys(mail).map((key) => {
        return (
          <MailItem key={key}
            refreshAccount={refreshAccount}
            pageType={pageType}
            data={mail[key]}
          />
        )
      });

      return (
        <Panel padding='none'>
          <MsgList>
            {list}
          </MsgList>
        </Panel>
      )
    }
  }
}

export default MailList;



// WEBPACK FOOTER //
// ./src/components/pages/Mail/MailList.jsx